import React from 'react'
import { useSelector } from 'react-redux'
import { useContext } from 'hooks/useURL'

const checkPatientReadOnly = () => {
  return WrappedComponent => {
    const CheckPatientReadOnly = props => {
      const archived = useSelector(state => state.patientDisplay?.patientDetails?.deleted_at)
      const context = useContext()
      const patientIsReadOnly = archived != null

      if (context === 'patientDisplay') {
        // this is a patient display window so see if the patient is read only
        return (
          <WrappedComponent
            // note this prop is picked up in HigherOrder lockable and
            // used to trigger the isLocked prop which is already in use
            patientIsReadOnly={patientIsReadOnly}
            {...props}
          />
        )
      } else {
        // not a patient dispaly window
        return <WrappedComponent {...props} />
      }
    }
    return CheckPatientReadOnly
  }
}
export default checkPatientReadOnly
